import { NO_WRAP } from "./../wix-rich-content-common";
const DIVIDER_TYPE = {
  LINE_SINGLE: "single",
  LINE_DOUBLE: "double",
  LINE_DASHED: "dashed",
  LINE_DOTTED: "dotted"
};
const ALIGN_CENTER = "center";
const SIZE_LARGE = "large";
const DEFAULTS = Object.freeze({
  type: DIVIDER_TYPE.LINE_SINGLE,
  config: {
    size: SIZE_LARGE,
    alignment: ALIGN_CENTER,
    textWrap: NO_WRAP
  }
});
export {
  DEFAULTS,
  DIVIDER_TYPE
};
//# sourceMappingURL=defaults.js.map
